function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 18 18"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M5.832 14.203a6.09 6.09 0 008.37-8.37l-8.37 8.37zm-2.035-2.035l8.371-8.37a6.09 6.09 0 00-8.37 8.37zM9 17.825A8.825 8.825 0 119 .175a8.825 8.825 0 010 17.65z",
  id: "a"
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#969EA2",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)",
  fill: "#959EA1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h18v18H0z"
})))));